import { User } from './user';

export class LoadingFormat {
  name!: string;
  description?: string;
  length!: number;
  width!: number;
  height!: number;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  static getSortColumns() {
    return ['name', 'length', 'width', 'height', 'status'];
  }

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.length = data.length;
    this.width = data.width;
    this.height = data.height;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
